module.exports = __webpack_public_path__ + "media/images/hamilton-cty-a3dd8d7fb7935e304742cbeb78c7dd00.png";